import { action, makeObservable, observable } from 'mobx'

import { RecentlyUpdatedMode } from '~/client/graph'
import InitialState, {
  IFilters,
  ISharedFilters,
} from '~/client/src/shared/stores/InitialState'

import { LogisticsFilterType } from '../../shared/enums/LogisticsFilterType'
import LogisticsGroupingOption from '../../shared/enums/LogisticsGroupingOption'
import UIFilterInfo from '../../shared/stores/substates/UIFilterInfo'

export default class MobileInitialState extends InitialState {
  public filters = observable<IMobileFilters>({
    selectedCustomFilterId: null,
    isFilterPageShown: false,
    selectedRecentlyUpdatedMode: RecentlyUpdatedMode.LastP6Update,
    recentlyUpdatedStartDate: null,
    recentlyUpdatedEndDate: null,
    currentDate: new Date(),
  })

  public formsFilters = observable<IFilters>({
    searchKey: '',
    groupingKey: LogisticsGroupingOption.TYPE,
    fieldsMap: {
      [LogisticsFilterType.Status]: new UIFilterInfo(),
      [LogisticsFilterType.Location]: new UIFilterInfo(),
      [LogisticsFilterType.Equipment]: new UIFilterInfo(),
      [LogisticsFilterType.Company]: new UIFilterInfo(),
      [LogisticsFilterType.Type]: new UIFilterInfo(),
      [LogisticsFilterType.ResponsibleContact]: new UIFilterInfo(),
      [LogisticsFilterType.Category]: new UIFilterInfo(),
      [LogisticsFilterType.Project]: new UIFilterInfo(),
      [LogisticsFilterType.Attachment]: new UIFilterInfo(),
    },
  })

  public constructor() {
    super()

    makeObservable(this)
  }

  @action.bound
  public clearProjectFilterSelections(): void {
    const projectFilters = [this.formsFilters]

    projectFilters.forEach(({ fieldsMap }) => {
      Object.values(fieldsMap).forEach(filter => filter.clear())
    })
  }
}

interface IMobileFilters extends ISharedFilters {
  selectedCustomFilterId: string
  isFilterPageShown: boolean
  currentDate: Date
}
